<template>
  <div :class="[deviceType, 'inner']">
    <div class="frame-36382">
      <div class="frame-1171275372">
        <AcknowledgementExpiredSvg></AcknowledgementExpiredSvg>
        <div class="div">!</div>
      </div>
      <div class="frame-1171275376">
        <div class="frame-15561">
          <div class="top-up-successful">
            {{ t("ccOnBoarding.acknowledgement.expired") }}
          </div>
        </div>
        <div class="wallet-limit-up-to-m">
          {{ t("ccOnBoarding.acknowledgement.expiredContent") }}
          <a class="link" :href="comsumerApi">
            {{ t("ccOnBoarding.acknowledgement.expiredContent2") }}
          </a>
          {{ t("ccOnBoarding.acknowledgement.expiredContent3") }}
        </div>
      </div>
    </div>
    <div class="refNo">
      {{ t("ccOnBoarding.acknowledgement.refNo") }} {{ prop.refNo }}
    </div>
  </div>
</template>
<script setup lang="ts">
import i18n from "@/plugin/i18n";
import { ref, onBeforeMount, onMounted } from "vue";
import { deviceDetect } from "mobile-device-detect";
import Constants from "@/constants/constants";
import AcknowledgementExpiredSvg from "@/assets/icons/AcknowledgementExpiredSvg.vue";

const { t } = i18n.global;
const comsumerApi = Constants.COMSUMER_API;

const deviceType = ref("");

const prop = defineProps({
  refNo: {
    type: String,
  },
});

onMounted(() => {
  const { isMobile, isTablet } = deviceDetect();

  if (isMobile) {
    deviceType.value = "Mobile";
  } else if (isTablet) {
    deviceType.value = "Tablet";
  } else {
    deviceType.value = "Desktop";
  }
});
</script>

<style scoped>
.frame-36382,
.frame-36382 * {
  box-sizing: border-box;
}
.frame-36382 {
  max-width: 1440px;
  margin: auto;
  padding: 0px 32px 0px 32px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  align-self: stretch;
  flex-shrink: 0;
  position: relative;
}
.frame-1171275372 {
  flex-shrink: 0;
  width: 60px;
  height: 60px;
  position: relative;
  overflow: hidden;
}
.polygon-1 {
  border-radius: 0px;
  width: 64px;
  height: 64px;
  position: absolute;
  left: calc(50% - 32px);
  top: 3.5px;
  overflow: visible;
}
.div {
  color: #ffffff;
  text-align: center;
  font-size: 32px;
  line-height: 130%;
  font-weight: 700;
  position: absolute;
  left: calc(50% - 5.5px);
  top: 15.86px;
}
.frame-1171275376 {
  display: flex;
  flex-direction: column;
  gap: 8px;
  align-items: center;
  justify-content: flex-start;
  align-self: stretch;
  flex-shrink: 0;
  position: relative;
}
.frame-15561 {
  display: flex;
  flex-direction: column;
  gap: 8px;
  align-items: center;
  justify-content: flex-start;
  align-self: stretch;
  flex-shrink: 0;
  position: relative;
}
.top-up-successful,
.top-up-successful * {
  margin-top: 20px;
  box-sizing: border-box;
}
.top-up-successful {
  color: var(--primary-active, #ac2887);
  text-align: center;
  font: 500 22px/130% "outfit";
  position: relative;
  align-self: stretch;
}

.wallet-limit-up-to-m,
.wallet-limit-up-to-m * {
  box-sizing: border-box;
  margin-top: 16px;
}
.wallet-limit-up-to-m {
  color: var(--black-medium-54, rgba(0, 0, 0, 0.54));
  text-align: center;
  font-family: var(--subtitle-1-medium-font-family, "Outfit", sans-serif);
  font-size: var(--subtitle-1-medium-font-size, 16px);
  line-height: var(--subtitle-1-medium-line-height, 130%);
  font-weight: var(--subtitle-1-medium-font-weight, 500);
  position: relative;
  align-self: stretch;
}

.refNo {
  color: var(--web-black-high, #212121);
  text-align: center;
  font-family: var(--h-3-font-family, "Outfit", sans-serif);
  font-size: var(--h-3-font-size, 18px);
  line-height: var(--h-3-line-height, 130%);
  font-weight: var(--h-3-font-weight, 500);
  position: relative;
  align-self: stretch;
  margin-top: 16px;
}

.inner:is(.Mobile) {
  padding: 20px 20px 0 20px;
}

.link {
  color: #212121;
  font-size: 16px;
  font-family: "Outfit";
  font-weight: 500;
  text-decoration: underline;
  line-height: 20.8px;
}
</style>
